import request, { setCsrfToken } from './request';

export async function auth(email: string, password: string) {
  return request('POST', '/api/auth', { email, password });
}

export async function logout() {
  const response = await request('DELETE', `/api/auth`);
  // Backend issues Set-Cookie with expired Max-Age to clear session/CSRF
  // cookies. We just drop the cached token here.
  setCsrfToken(null);
  return response;
}

export async function me() {
  return request('GET', '/api/auth/me');
}
